const warnMessages = {
  TRACK_NAME_IS_REQUIRED: 'trackName parameter is required',
  ANALYTICS_IS_NOT_INITIALIZED: 'windows analytics is not initialized',
  ELEMENT_PARAMETER_IS_REQUIRED: 'elementName parameter is required',
  CTA_NAME_IS_REQUIRED: 'cta_name parameter is required',
};

export default warnMessages;
